import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeoMapPrecastComponent } from './geo-map-precast.component';

const routes: Routes = [
  {
    path: '',
    component: GeoMapPrecastComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GeoMapPrecastRoutingModule {}
